import { generateRoutePath } from './generateRoutePath'

/**
 * Páginas que existem antes de haver sessão: login, convite e recuperação de
 * senha. Nenhuma delas conta como visita, e nenhuma delas tem página aberta no
 * cronômetro para fechar.
 *
 * A lista mora aqui, e não dentro do middleware, porque hoje tem dois leitores
 * em runtimes diferentes: o `accessedPagesMiddleware` (servidor do Next, avisa
 * a entrada) e o `usePageExitBeacon` (navegador, avisa a saída da aba). Duas
 * cópias divergem na primeira vez que só uma for editada.
 */
const PUBLIC_PAGES: Array<string | RegExp> = [
  generateRoutePath('login'),
  generateRoutePath('loginByRegistration'),
  generateRoutePath('verifyCode'),
  generateRoutePath('resetPassword'),
  new RegExp(
    `^${generateRoutePath('invite.id', { params: { id: '[^/]+' } }).replace(
      ':id',
      '[^/]+',
    )}$`,
  ),
  new RegExp(
    `^${generateRoutePath('resetPassword.token', {
      params: { token: '[^/]+' },
    }).replace(':token', '[^/]+')}$`,
  ),
  '/favicon.ico',
]

export function isPublicPage(pathname: string): boolean {
  return PUBLIC_PAGES.some((page) =>
    typeof page === 'string' ? page === pathname : page.test(pathname),
  )
}
